<template>
  <div class="figureRaderChart">
    <canvas :ref="(el) => radarChartRef = el"></canvas>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, watch} from "vue";
  import {Chart} from "chart.js";

  const props = defineProps<{
    chartData: any;
    name: string
  }>();
  const radarChartRef = ref(null)
  const chart = ref(null);
  const options = ref({
    scale:{
      ticks:{
        display: false,
        min: 0,
        max: 100,
        stepSize: 20,
      },
      gridLines: {
        display: false,
      },
      angleLines: {
        display: true,
        color: 'rgba(51, 51, 51, 1)',
      },
      pointLabels: {
        fontSize: 16,
        fontStyle: "700",
        fontFamily: 'BIZ UDGothic',
        fontColor: '#333',
      },
    },
    legend: {
      display: false
    },
    tooltips: {
      mode: 'nearest',
      backgroundColor: "rgba(221, 221, 221, 1)",
      borderColor: "rgba(0, 0, 0, 1)",
      titleFontSize: 17,
      titleFontFamily: 'BIZ UDGothic',
      titleFontStyle: '700',
      titleFontColor: "rgba(51, 51, 51, 1)",
      bodyFontSize: 14,
      bodyFontFamily: 'BIZ UDGothic',
      bodyFontStyle: '700',
      bodyFontColor: "rgba(51, 51, 51, 1)",
      bodySpacing: 10,
      xPadding: 10,
      yPadding: 10,
      callbacks: {
        title: function(tooltipItem, data){
          return data.labels[tooltipItem[0].index]
        },
        labelColor: function(tooltipItem, chart) {
          let dataset = chart.data.datasets[tooltipItem.datasetIndex];
          return {
            borderColor: dataset.borderColor,
            backgroundColor: dataset.backgroundColor
          }
        },
      },
    },
    maintainAspectRatio: false,
  });

  onMounted(() => {
    const ctx = radarChartRef.value;
    chart.value = new Chart(ctx, {
        type: "radar",
        data: props.chartData,
        options: options.value
      }
    )
  })
  watch(
    () => props.chartData,
    () => {
      chart.value.data = props.chartData;
      chart.value.update();
    }
  )
</script>